/**
 * CMP（データ利用同意管理）エントリポイント
 *
 * DOMContentLoaded時に<script type="application/json" id="cmp-config">から
 * 設定を自動読み取りしてCMPを初期化する。
 * 外部からのClipkit.cmp.run()呼び出しは不要。
 */

import cmp from '../cmp';

// Clipkit名前空間に統合
window.Clipkit = window.Clipkit || {};
window.Clipkit.cmp = cmp;

document.addEventListener('DOMContentLoaded', function () {
  const configEl = document.getElementById('cmp-config');
  if (!configEl) return;

  try {
    const config = JSON.parse(configEl.textContent);
    cmp.run(config);
  } catch (e) {
    console.error('[CMP] Failed to parse config:', e);
  }
});
